
class Car {
  static getNew () {
    return {
      info: {
        make: '',
        model: '',
        domain: '',
        year: '',
        color: '',
        engine_number: '',
        chassis_number: ''
      },
      state: {
        location: {
          coordinates: [-34.5303537853517, -58.497111797332764]
        }
      }
    }
  }
}

export { Car }



// WEBPACK FOOTER //
// ./src/models/car.js